export const isMAC = MAC => MAC.match(/^(?:|(?:[0-9a-fA-F]{2}:){5}[0-9a-fA-F]{2})$/i);

export const isIMEI = IMEI => IMEI.match(/^(?:|\d{15})$/);